import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const CZ: DeepPartial<OwnTransfer> = {
    descriptionAttributeMapping: 'additionalInfo.text4x35[0]',
    descriptionMaxLength: 35,
    isCollectiveSigningInfoDisplayed: true,
    shouldSwitchDirectionByDefault: true,
};
